import types from "./types";

const INITIAL_STATE = {
	equipmentFormBuilder: null,

	equipmentFormBuilderError: null,
	equipmentFormBuilderLoading: false,

	//select item

	selectItem: null,
};

const EquipmentFromReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_EQUIPMENTFORMLIST_START:
			return {
				...state,
				equipmentFormBuilder: null,
				equipmentFormBuilderError: null,
				equipmentFormBuilderLoading: true,
			};
		case types.GET_EQUIPMENTFORMLIST_SUCCESS:
			return {
				...state,
				equipmentFormBuilder: action.payload,
				equipmentFormBuilderLoading: false,
			};
		case types.GET_EQUIPMENTFORMLIST_ERROR:
			return {
				...state,
				equipmentFormBuilderError: action.payload,
				equipmentFormBuilderLoading: false,
			};
		case types.GET_EQUIPMENTFORMLIST_RESET:
			return {
				...state,
				equipmentFormBuilderError: null,
				equipmentFormBuilderLoading: false,
			};
		//create

		case types.SELECT_TOUPDATE_ITEM:
			return {
				...state,
				selectItem: action.payload,
			};

		default:
			return { ...state };
	}
};

export default EquipmentFromReducer;
